namespace GeniuzPOS.ReportMasterData {
    export interface Report_1333Form {
    }

    export class Report_1333Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1333';
    }
}
